import { CONTENT_MOCK_DELAYS } from "@/constants";
import { findMockPolicyPage, getMockPolicyNavigation } from "@/mocks/content";
import { mockRequest } from "@/mocks/mock-request";
import { PolicyService } from "@/types";

export const mockPolicyProvider: PolicyService = {
  async getBySlug(slug: string) {
    return mockRequest(findMockPolicyPage(slug) ?? null, {
      delay: CONTENT_MOCK_DELAYS.policyDetail,
    });
  },

  async getNavigation() {
    return mockRequest(getMockPolicyNavigation(), {
      delay: CONTENT_MOCK_DELAYS.policyFooter,
    });
  },
};
